<mat-form-field floatLabel="always" class="flex grow">
  <mat-label>Allocate To</mat-label>
  <mat-select
    [formControl]="formCtrl"
    [placeholder]="autoAllocated"
    [compareWith]="isSameRef"
  >
    <mat-option [value]="undefined">{{ autoAllocated }}</mat-option>
    @for (staffer of staff; track staffer.ref.path) {
      <mat-option [value]="staffer.ref">
        {{ staffer.name }}
      </mat-option>
    }
  </mat-select>
  <mat-hint>{{ autoAllocateTooltip }}</mat-hint>

  @if (invoice) {
    <ng-container matSuffix>
      <mat-icon
        #allocationBreakdownTarget="cdkOverlayOrigin"
        cdkOverlayOrigin
        class="icon-sm shrink-0 opacity-50"
      >
        info
      </mat-icon>
      <pt-custom-tooltip [target]="allocationBreakdownTarget">
        <ng-template ptCustomTooltipContent>
          <div class="flex flex-col gap-4 p-4">
            <pr-practitioner-allocation-breakdown [invoice]="invoice" />
          </div>
        </ng-template>
      </pt-custom-tooltip>
    </ng-container>
  }
</mat-form-field>
